// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"29313d27","453":"2c464315","695":"569dc528"}[chunkId] + ".chunk.js";
};